// @flow
import React from 'react';

class SMEnterpriseSentView extends React.Component {

  render() {
    return (
      <div className="site-main">
        <div className="page__even">
          <div className="container">
            <h2 className="enterprise__contact-title">お問い合わせを送信しました</h2>
            <p className="enterprise__contact-text">
            シェアリング型イベントマーケティングへのお問い合わせありがとうございました！<br />
            担当より約3営業日以内にご連絡いたしますので、 しばらくお待ちください。
            </p>
            <div className="ta-c mb50">
              <a href={Routes.root_path} className="button-blue mt20 pt15 pb15 w300 sm-w100">{I18n.t("service.label_000114")}</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SMEnterpriseSentView;



// WEBPACK FOOTER //
// ./app/javascript/components/enterprises/SMEnterpriseSentView.jsx